<div class="sp-dialog__max-width-s sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__primary">{{ 'COMPANIES.FILTER_CTA' | translate }}:</h3>
    <form
      [formGroup]="companies_filters_from_group"
      class="sp-margin__top-x2 sp-row__space sp-wrap">
      <mat-form-field
        class="sp-width__full"
        appearance="fill"
        color="accent">
        <mat-label> ID </mat-label>
        <input
          matInput
          type="text"
          formControlName="company_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'STORES.BUSINESS_NAME_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="business_name"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'STORES.VAT_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="vat"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'COMPANIES.SALES_NETWORK_ID_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="sales_network_id"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}
        </mat-label>
        <mat-select
          formControlName="status"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="pending_evaluation">
            {{ getCompanyStatusLabel(pending_evaluation) | translate }}
          </mat-option>
          <mat-option [value]="pending_signature">
            {{ getCompanyStatusLabel(pending_signature) | translate }}
          </mat-option>
          <mat-option [value]="pending_acceptance">
            {{ getCompanyStatusLabel(pending_acceptance) | translate }}
          </mat-option>
          <mat-option [value]="accepted">
            {{ getCompanyStatusLabel(accepted) | translate }}
          </mat-option>
          <mat-option [value]="denied">
            {{ getCompanyStatusLabel(denied) | translate }}
          </mat-option>
          <mat-option [value]="partially_enabled">
            {{ getCompanyStatusLabel(partially_enabled) | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'COMPANIES.PRODUCT_CATEGORY' | translate }}
        </mat-label>
        <mat-select
          formControlName="product_category"
          [errorStateMatcher]="error_matcher">
          <mat-option [value]="clothing">{{ 'COMPANIES.PRODUCT_CATEGORY_CLOTHING' | translate }}</mat-option>

          <mat-option [value]="real_estate_agencies">{{
            'COMPANIES.PRODUCT_CATEGORY_REAL_ESTATE_AGENCIES' | translate
          }}</mat-option>
          <mat-option [value]="hearing_aids">{{ 'COMPANIES.PRODUCT_CATEGORY_HEARING_AIDS' | translate }}</mat-option>

          <mat-option [value]="furniture">{{ 'COMPANIES.PRODUCT_CATEGORY_FURNITURE' | translate }}</mat-option>
          <mat-option [value]="home_and_bathroom_furniture">{{
            'COMPANIES.PRODUCT_CATEGORY_HOME_AND_BATHROOM_FURNITURE' | translate
          }}</mat-option>

          <mat-option [value]="musical_instruments">{{
            'COMPANIES.PRODUCT_CATEGORY_MUSICAL_INSTRUMENTS' | translate
          }}</mat-option>

          <mat-option [value]="sporting_goods">{{
            'COMPANIES.PRODUCT_CATEGORY_SPORTING_GOODS' | translate
          }}</mat-option>

          <mat-option [value]="insurance">{{ 'COMPANIES.PRODUCT_CATEGORY_INSURANCE' | translate }}</mat-option>
          <mat-option [value]="bicycles">{{ 'COMPANIES.PRODUCT_CATEGORY_BICYCLES' | translate }}</mat-option>
          <mat-option [value]="bodywork">{{ 'COMPANIES.PRODUCT_CATEGORY_BODYWORK' | translate }}</mat-option>
          <mat-option [value]="furniture_accessories">{{
            'COMPANIES.PRODUCT_CATEGORY_FURNITURE_ACCESSORIES' | translate
          }}</mat-option>
          <mat-option [value]="dealers">{{ 'COMPANIES.PRODUCT_CATEGORY_DEALERS' | translate }}</mat-option>

          <mat-option [value]="cosmetics_beauty">{{
            'COMPANIES.PRODUCT_CATEGORY_COSMETICS_BEAUTY' | translate
          }}</mat-option>

          <mat-option [value]="door_to_door">{{ 'COMPANIES.PRODUCT_CATEGORY_DOOR_TO_DOOR' | translate }}</mat-option>

          <mat-option [value]="diy_and_home_improvement">{{
            'COMPANIES.PRODUCT_CATEGORY_DIY_AND_HOME_IMPROVEMENT' | translate
          }}</mat-option>

          <mat-option [value]="physiotherapy_osteopathy">{{
            'COMPANIES.PRODUCT_CATEGORY_PHYSIOTHERAPY_OSTEOPATHY' | translate
          }}</mat-option>

          <mat-option [value]="training_and_courses">{{
            'COMPANIES.PRODUCT_CATEGORY_TRAINING_AND_COURSES' | translate
          }}</mat-option>

          <mat-option [value]="tire_dealers">{{ 'COMPANIES.PRODUCT_CATEGORY_TIRE_DEALERS' | translate }}</mat-option>

          <mat-option [value]="home_alarm_systems">{{
            'COMPANIES.PRODUCT_CATEGORY_HOME_ALARM_SYSTEMS' | translate
          }}</mat-option>
          <mat-option [value]="car_alarm_systems">{{
            'COMPANIES.PRODUCT_CATEGORY_CAR_ALARM_SYSTEMS' | translate
          }}</mat-option>

          <mat-option [value]="car_motorcycle_repair_shops">{{
            'COMPANIES.PRODUCT_CATEGORY_CAR_MOTORCYCLE_REPAIR_SHOPS' | translate
          }}</mat-option>

          <mat-option [value]="opticians">{{ 'COMPANIES.PRODUCT_CATEGORY_OPTICIANS' | translate }}</mat-option>

          <mat-option [value]="gyms">{{ 'COMPANIES.PRODUCT_CATEGORY_GYMS' | translate }}</mat-option>

          <mat-option [value]="bed_bases_and_mattresses">{{
            'COMPANIES.PRODUCT_CATEGORY_BED_BASES_AND_MATTRESSES' | translate
          }}</mat-option>

          <mat-option [value]="energy_renovation">{{
            'COMPANIES.PRODUCT_CATEGORY_ENERGY_RENOVATION' | translate
          }}</mat-option>

          <mat-option [value]="doors_and_windows">{{
            'COMPANIES.PRODUCT_CATEGORY_DOORS_AND_WINDOWS' | translate
          }}</mat-option>

          <mat-option [value]="professional_services">{{
            'COMPANIES.PRODUCT_CATEGORY_PROFESSIONAL_SERVICES' | translate
          }}</mat-option>

          <mat-option [value]="dental_clinics">{{
            'COMPANIES.PRODUCT_CATEGORY_DENTAL_CLINICS' | translate
          }}</mat-option>

          <mat-option [value]="medical_practices">{{
            'COMPANIES.PRODUCT_CATEGORY_MEDICAL_PRACTICES' | translate
          }}</mat-option>

          <mat-option [value]="veterinarians">{{ 'COMPANIES.PRODUCT_CATEGORY_VETERINARIANS' | translate }}</mat-option>

          <mat-option [value]="stoves_and_fireplaces">{{
            'COMPANIES.PRODUCT_CATEGORY_STOVES_AND_FIREPLACES' | translate
          }}</mat-option>

          <mat-option [value]="leisure">{{ 'COMPANIES.PRODUCT_CATEGORY_LEISURE' | translate }}</mat-option>

          <mat-option [value]="tv_telephony_and_electronics">{{
            'COMPANIES.PRODUCT_CATEGORY_TV_TELEPHONY_AND_ELECTRONICS' | translate
          }}</mat-option>

          <mat-option [value]="other">{{ 'GENERAL.OTHER_LABEL' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'GENERAL.AGREEMENT_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="agreement"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <mat-form-field
        class="sp-width__full sp-width__full-md sp-margin__top-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'COMPANIES.ORIGIN_COLUMN_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="origin"
          [errorStateMatcher]="error_matcher" />
      </mat-form-field>

      <div class="sp-row__end sp-width__full sp-margin__top">
        <p
          (click)="onClearFiltersClick()"
          class="p-color__accent sp-text__right sp-text__hover">
          {{ 'GENERAL.CLEAR_FILTERS_CTA' | translate }}
        </p>
      </div>

      <div class="sp-margin__top-x4 sp-width__full">
        <app-shared-button
          class="sp-width__full"
          [cta]="'GENERAL.APPLY_FILTERS_CTA'"
          [is_disabled]="!isFormValid()"
          (button_click)="onApplyFiltersClick()"></app-shared-button>
      </div>
    </form>
  </div>
</div>
